import { ConnectedContentHttpClient } from '../../common/services/httpClient';

export const getConnectedContent = async (projectId, contentId) => {
  const response = await ConnectedContentHttpClient.get(
    `projects/${projectId}/connections/${contentId}`
  );
  const connectedContent = {};
  Object.keys(response.data).forEach((key) => {
    connectedContent[key] = response.data[key].items;
  });
  return connectedContent;
};

export const getAllPossibleConnections = async (projectId) => {
  const response = await ConnectedContentHttpClient.get(
    `projects/${projectId}`
  );
  const connections = {};
  Object.keys(response.data).forEach((key) => {
    connections[key] = response.data[key].items;
  });
  return connections;
};
